import { useApi } from '@/api';
import { ChartSkeleton } from '@/components';
import { useChartTooltip } from '@/hooks';
import { DoughnutChart, Flex, formatPercentage } from '@blockanalitica/ui';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Psm3AssetDonutChart() {
  const [data, error] = useApi({
    url: `/arbitrum/psm3/share/`
  });

  if (error) {
    throw error;
  }
  const navigate = useNavigate();
  const customTooltip = useChartTooltip(
    data,
    'symbol',
    'percent_of_total',
    true,
    'balance'
  );

  const chartData = useMemo(() => {
    if (data) {
      const colors = {
        sUSDS: 'rgba(0, 245, 170, 0.55)',
        USDC: 'rgba(39, 117, 202, 0.55)',
        USDS: 'rgba(255, 139, 91, 0.55)'
      };
      return {
        labels: data.map((row) => row.symbol),
        datasets: [
          {
            data: data.map((row) => row.percent_of_total),
            backgroundColor: data.map((row) => colors[row.symbol]),
            borderColor: data.map((row) => colors[row.symbol]),
            hoverOffset: 30
          }
        ]
      };
    }
    return null;
  }, [data]);

  const mapping = useMemo(() => {
    if (data) {
      return data.reduce((acc, row) => {
        const key = row.symbol;
        acc[key] = row.wallet_address;
        return acc;
      }, {});
    }
    return {};
  }, [data]);
  const customConfig = useMemo(
    () => ({
      options: {
        aspectRatio: 1.8,
        layout: {
          padding: 10
        },
        plugins: {
          legend: {
            position: 'bottom'
          },
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: customTooltip
          }
        }
      }
    }),
    [customTooltip]
  );

  if (data) {
    return (
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        paddingTop="m"
        width="100%">
        <DoughnutChart
          // @ts-ignore
          config={customConfig}
          data={chartData}
          valueFormatter={formatPercentage}
          mapping={mapping}
          navigate={navigate}
        />
      </Flex>
    );
  }

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      paddingTop="m"
      width="100%">
      <ChartSkeleton type="doughnut" />
    </Flex>
  );
}
